var poll_default = {
  "fontElementMap": "JByEG",
  "container": "bBi2Y",
  "fullscreen": "_8UqKk",
  "background_overlay": "nO0z0",
  "with_image": "Ee-eZ",
  "options": "D0fom",
  "webview": "_06jPK",
  "grid": "aqLST",
  "option": "XD50J",
  "cta_button": "NXdGU",
  "add_option": "Rezan",
  "see_more": "_2ouaO",
  "list": "_1b474",
  "column": "_9kbI3",
  "additional_note": "xN4i8",
  "spinner": "C61c2",
  "spin": "MuCUU",
  "shown": "dD9pn",
  "error": "TECLh"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
